import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import moment from 'moment'

import { Form, Text } from 'components/forms'
import { DateIntervalForm } from 'components/shared/DateIntervalForm'
import { Modal } from 'components/Modal'
import Button from 'components/Button'
import Divider from 'components/Divider'
import localDateFormatter from 'helpers/localDateFormatter'

const DatePeriod = ({ value, onChange, label, labelPeriod, disabled, ...dateIntervalProps }) => {
	const [showModal, setShowModal] = useState(false)
	const [t, language] = useTranslation()

	const start = value?.fromDateTime
	const startMoment = moment(start)
	const end = value?.toDateTime
	const endMoment = moment(end)
	const isPeriod = endMoment.diff(startMoment, 'days') >= 1

	const getField = () => {
		const fieldProps = {
			noForm: true,
			onFocus: e => setShowModal(true),
			shrink: true,
			readOnly: true
		}

		return isPeriod ?
			<>
				<Text
					{...fieldProps}
					value={localDateFormatter({ date: start, language }) || ''}
					label={labelPeriod?.from}
					inline
					disabled={disabled}
				/>
				<Text
					{...fieldProps}
					value={localDateFormatter({ date: end, language }) || ''}
					label={labelPeriod?.to}
					inline
					disabled={disabled}
				/>
			</>
			:
			<>
				<Text
					{...fieldProps}
					value={localDateFormatter({ date: start, language }) || ''}
					label={label}
					disabled={disabled}
				/>
				{/* Empty div for equal bottom margings of Text */}
				<div />
			</>
	}

	return (
		<div>
			{getField()}
			{showModal &&
				<Modal unmount={() => setShowModal(false)} label={t('common.strings.date_period')} width={500}>
					<Form
						initialValues={{ period: { from: start, to: end } }}
						onSubmit={({ period }) => {
							let newPeriod
							if (moment.isMoment(period)) {
								newPeriod = { from: moment(period).utc().startOf('day'), to: moment(period).utc().endOf('day') }
							}
							setShowModal(false)
							onChange(newPeriod ? newPeriod : period)
						}}
					>
						<DateIntervalForm {...dateIntervalProps} />
						<Divider />
						<Button type='submit' text='anwenden' />
					</Form>
				</Modal>
			}
		</div>
	)
}

export default DatePeriod
